export const isoConfig = [
    {
        name: 'CAISO',
        mapLayerTitle: 'CAISO',
        mutualExclusiveLayers: ['CAISO w/ EIM'],
        studies: [
            {
                name: 'Standardized Congestion Persistence',
                years: [
                    { year: 2036, fieldName: 'StandardizedCP_2036', isForecasted: true },
                    { year: 2032, fieldName: 'StandardizedCP_2032', isForecasted: true },
                    { year: 2028, fieldName: 'StandardizedCP_2028', isForecasted: true },
                    { year: 2024, fieldName: 'StandardizedCP_2024', isForecasted: true },
                    { year: 2020, fieldName: 'StandardizedCP_2020' },
                    { year: 2019, fieldName: 'StandardizedCP_2019' },
                    { year: 2018, fieldName: 'StandardizedCP_2018' },
                    { year: 2017, fieldName: 'StandardizedCP_2017' },
                    { year: 2016, fieldName: 'StandardizedCP_2016' },
                    { year: 'Overall', fieldName: 'StandardizedCP_Overall' },
                ],
                hasForecastedData: true,
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The standardized CP is the absolute CP divided by $50,000/MW.',
            },
            {
                name: 'Relative Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'RelativeCP_2020' },
                    { year: 2019, fieldName: 'RelativeCP_2019' },
                    { year: 2018, fieldName: 'RelativeCP_2018' },
                    { year: 2017, fieldName: 'RelativeCP_2017' },
                    { year: 2016, fieldName: 'RelativeCP_2016' },
                    { year: 'Overall', fieldName: 'RelativeCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The relative CP is the absolute CP divided by the median absolute CP for the specified year/ISO. The median CPs for each year are as follows, in $/MW.2016: $66662, 2017: $109116, 2018: $80157, 2019: $88255, 2020: $59490.',
            },
            {
                name: 'DA Basis',
                years: [
                    { year: 2036, fieldName: 'DABasis_2036', isForecasted: true },
                    { year: 2032, fieldName: 'DABasis_2032', isForecasted: true },
                    { year: 2028, fieldName: 'DABasis_2028', isForecasted: true },
                    { year: 2024, fieldName: 'DABasis_2024', isForecasted: true },
                    { year: 2020, fieldName: 'DABasis_2020' },
                    { year: 2019, fieldName: 'DABasis_2019' },
                    { year: 2018, fieldName: 'DABasis_2018' },
                    { year: 2017, fieldName: 'DABasis_2017' },
                    { year: 2016, fieldName: 'DABasis_2016' },
                    { year: 'Overall', fieldName: 'DABasis_Overall' },
                ],
                hasForecastedData: true,
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub. The basis for a node in CA is defined relative to TH_ZP26_GEN-APND, TH_NP15_GEN-APND, or TH_SP15_GEN-APND, depending on location. Nodes outside of CA do not currently have basis definitions. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'DART Spread',
                years: [
                    { year: 2020, fieldName: 'DARTSpread_2020' },
                    { year: 2019, fieldName: 'DARTSpread_2019' },
                    { year: 2018, fieldName: 'DARTSpread_2018' },
                    { year: 2017, fieldName: 'DARTSpread_2017' },
                    { year: 2016, fieldName: 'DARTSpread_2016' },
                    { year: 'Overall', fieldName: 'DARTSpread_Overall' },
                ],
                description:
                    'The DART spread is the arithmetic mean of the difference between day-ahead and real-time prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean DA Price',
                years: [
                    { year: 2020, fieldName: 'MeanDAPrice_2020' },
                    { year: 2019, fieldName: 'MeanDAPrice_2019' },
                    { year: 2018, fieldName: 'MeanDAPrice_2018' },
                    { year: 2017, fieldName: 'MeanDAPrice_2017' },
                    { year: 2016, fieldName: 'MeanDAPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanDAPrice_2020' },
                ],
                description:
                    'The mean DA price is the arithmetic mean of all day-ahead prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean Peak Price',
                years: [
                    { year: 2020, fieldName: 'MeanPeakPrice_2020' },
                    { year: 2019, fieldName: 'MeanPeakPrice_2019' },
                    { year: 2018, fieldName: 'MeanPeakPrice_2018' },
                    { year: 2017, fieldName: 'MeanPeakPrice_2017' },
                    { year: 2016, fieldName: 'MeanPeakPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanPeakPrice_Overall' },
                ],
                description:
                    'The mean peak price is the arithmetic mean of all real-time prices for the specified node during summer evening hours, measured in $/MWh.',
            },
            {
                name: 'Mean RT Price',
                years: [
                    { year: 2020, fieldName: 'MeanRTPrice_2020' },
                    { year: 2019, fieldName: 'MeanRTPrice_2019' },
                    { year: 2018, fieldName: 'MeanRTPrice_2018' },
                    { year: 2017, fieldName: 'MeanRTPrice_2017' },
                    { year: 2016, fieldName: 'MeanRTPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanRTPrice_Overall' },
                ],
                description:
                    'The mean RT price is the arithmetic mean of all real-time prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'RT Basis',
                years: [
                    { year: 2020, fieldName: 'RTBasis_2020' },
                    { year: 2019, fieldName: 'RTBasis_2019' },
                    { year: 2018, fieldName: 'RTBasis_2018' },
                    { year: 2017, fieldName: 'RTBasis_2017' },
                    { year: 2016, fieldName: 'RTBasis_2016' },
                    { year: 'Overall', fieldName: 'RTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub. The basis for a node in CA is defined relative to TH_ZP26_GEN-APND, TH_NP15_GEN-APND, or TH_SP15_GEN-APND, depending on location. Nodes outside of CA do not currently have basis definitions. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted Avg Price',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedAveragePrice_2020' },
                    { year: 2019, fieldName: 'Solar_weightedAveragePrice_2019' },
                    { year: 2018, fieldName: 'Solar_weightedAveragePrice_2018' },
                    { year: 2017, fieldName: 'Solar_weightedAveragePrice_2017' },
                    { year: 2016, fieldName: 'Solar_weightedAveragePrice_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedAveragePrice_Over' },
                ],
                description:
                    'The solar-weighted average price is the arithmetic mean of all real-time prices for the specified node, weighted by solar production at its location. The metric is measured in $/MWh. It can be interpreted as the average price that each MWh of solar energy can be expected to sell for.',
            },
            {
                name: 'Solar-weighted DA Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedDABasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedDABasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedDABasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedDABasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedDABasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedDABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub, weighted by solar-energy production. The basis for a node in CA is defined relative to TH_ZP26_GEN-APND, TH_NP15_GEN-APND, or TH_SP15_GEN-APND, depending on location. Nodes outside of CA do not currently have basis definitions. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted RT Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedRTBasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedRTBasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedRTBasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedRTBasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedRTBasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedRTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub, weighted by solar-energy production. The basis for a node in CA is defined relative to TH_ZP26_GEN-APND, TH_NP15_GEN-APND, or TH_SP15_GEN-APND, depending on location. Nodes outside of CA do not currently have basis definitions. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Volatility',
                years: [
                    { year: 2020, fieldName: 'Volatility_2020' },
                    { year: 2019, fieldName: 'Volatility_2019' },
                    { year: 2018, fieldName: 'Volatility_2018' },
                    { year: 2017, fieldName: 'Volatility_2017' },
                    { year: 2016, fieldName: 'Volatility_2016' },
                    { year: 'Overall', fieldName: 'Volatility_Overall' },
                ],
                description:
                    'Volatility is the standard deviation of the 5-min real-time price for the specified node, measured in $/MWh.',
            },
        ],
    },
    {
        name: 'CAISO w/ EIM',
        mapLayerTitle: 'CAISO w/ EIM',
        mutualExclusiveLayers: ['CAISO'],
        studies: [
            {
                name: 'Standardized Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'StandardizedCP_2020' },
                    { year: 2019, fieldName: 'StandardizedCP_2019' },
                    { year: 2018, fieldName: 'StandardizedCP_2018' },
                    { year: 2017, fieldName: 'StandardizedCP_2017' },
                    { year: 2016, fieldName: 'StandardizedCP_2016' },
                    { year: 'Overall', fieldName: 'StandardizedCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The standardized CP is the absolute CP divided by $50,000/MW.',
            },
            {
                name: 'Relative Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'RelativeCP_2020' },
                    { year: 2019, fieldName: 'RelativeCP_2019' },
                    { year: 2018, fieldName: 'RelativeCP_2018' },
                    { year: 2017, fieldName: 'RelativeCP_2017' },
                    { year: 2016, fieldName: 'RelativeCP_2016' },
                    { year: 'Overall', fieldName: 'RelativeCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The relative CP is the absolute CP divided by the median absolute CP for the specified year/ISO. The median CPs for each year are as follows, in $/MW.2016: $66662, 2017: $109116, 2018: $80157, 2019: $88255, 2020: $59490.',
            },
            {
                name: 'DA Basis',
                years: [
                    { year: 2020, fieldName: 'DABasis_2020' },
                    { year: 2019, fieldName: 'DABasis_2019' },
                    { year: 2018, fieldName: 'DABasis_2018' },
                    { year: 2017, fieldName: 'DABasis_2017' },
                    { year: 2016, fieldName: 'DABasis_2016' },
                    { year: 'Overall', fieldName: 'DABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub. The basis for a node in CA is defined relative to TH_ZP26_GEN-APND, TH_NP15_GEN-APND, or TH_SP15_GEN-APND, depending on location. Nodes outside of CA do not currently have basis definitions. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'DART Spread',
                years: [
                    { year: 2020, fieldName: 'DARTSpread_2020' },
                    { year: 2019, fieldName: 'DARTSpread_2019' },
                    { year: 2018, fieldName: 'DARTSpread_2018' },
                    { year: 2017, fieldName: 'DARTSpread_2017' },
                    { year: 2016, fieldName: 'DARTSpread_2016' },
                    { year: 'Overall', fieldName: 'DARTSpread_Overall' },
                ],
                description:
                    'The DART spread is the arithmetic mean of the difference between day-ahead and real-time prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean DA Price',
                years: [
                    { year: 2020, fieldName: 'MeanDAPrice_2020' },
                    { year: 2019, fieldName: 'MeanDAPrice_2019' },
                    { year: 2018, fieldName: 'MeanDAPrice_2018' },
                    { year: 2017, fieldName: 'MeanDAPrice_2017' },
                    { year: 2016, fieldName: 'MeanDAPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanDAPrice_2020' },
                ],
                description:
                    'The mean DA price is the arithmetic mean of all day-ahead prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean Peak Price',
                years: [
                    { year: 2020, fieldName: 'MeanPeakPrice_2020' },
                    { year: 2019, fieldName: 'MeanPeakPrice_2019' },
                    { year: 2018, fieldName: 'MeanPeakPrice_2018' },
                    { year: 2017, fieldName: 'MeanPeakPrice_2017' },
                    { year: 2016, fieldName: 'MeanPeakPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanPeakPrice_Overall' },
                ],
                description:
                    'The mean peak price is the arithmetic mean of all real-time prices for the specified node during summer evening hours, measured in $/MWh.',
            },
            {
                name: 'Mean RT Price',
                years: [
                    { year: 2020, fieldName: 'MeanRTPrice_2020' },
                    { year: 2019, fieldName: 'MeanRTPrice_2019' },
                    { year: 2018, fieldName: 'MeanRTPrice_2018' },
                    { year: 2017, fieldName: 'MeanRTPrice_2017' },
                    { year: 2016, fieldName: 'MeanRTPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanRTPrice_Overall' },
                ],
            },
            {
                name: 'RT Basis',
                years: [
                    { year: 2020, fieldName: 'RTBasis_2020' },
                    { year: 2019, fieldName: 'RTBasis_2019' },
                    { year: 2018, fieldName: 'RTBasis_2018' },
                    { year: 2017, fieldName: 'RTBasis_2017' },
                    { year: 2016, fieldName: 'RTBasis_2016' },
                    { year: 'Overall', fieldName: 'RTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub. The basis for a node in CA is defined relative to TH_ZP26_GEN-APND, TH_NP15_GEN-APND, or TH_SP15_GEN-APND, depending on location. Nodes outside of CA do not currently have basis definitions. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted Avg Price',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedAveragePrice_2020' },
                    { year: 2019, fieldName: 'Solar_weightedAveragePrice_2019' },
                    { year: 2018, fieldName: 'Solar_weightedAveragePrice_2018' },
                    { year: 2017, fieldName: 'Solar_weightedAveragePrice_2017' },
                    { year: 2016, fieldName: 'Solar_weightedAveragePrice_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedAveragePrice_Over' },
                ],
                description:
                    'The solar-weighted average price is the arithmetic mean of all real-time prices for the specified node, weighted by solar production at its location. The metric is measured in $/MWh. It can be interpreted as the average price that each MWh of solar energy can be expected to sell for.',
            },
            {
                name: 'Solar-weighted DA Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedDABasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedDABasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedDABasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedDABasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedDABasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedDABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub, weighted by solar-energy production. The basis for a node in CA is defined relative to TH_ZP26_GEN-APND, TH_NP15_GEN-APND, or TH_SP15_GEN-APND, depending on location. Nodes outside of CA do not currently have basis definitions. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted RT Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedRTBasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedRTBasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedRTBasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedRTBasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedRTBasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedRTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub, weighted by solar-energy production. The basis for a node in CA is defined relative to TH_ZP26_GEN-APND, TH_NP15_GEN-APND, or TH_SP15_GEN-APND, depending on location. Nodes outside of CA do not currently have basis definitions. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Volatility',
                years: [
                    { year: 2020, fieldName: 'Volatility_2020' },
                    { year: 2019, fieldName: 'Volatility_2019' },
                    { year: 2018, fieldName: 'Volatility_2018' },
                    { year: 2017, fieldName: 'Volatility_2017' },
                    { year: 2016, fieldName: 'Volatility_2016' },
                    { year: 'Overall', fieldName: 'Volatility_Overall' },
                ],
                description:
                    'Volatility is the standard deviation of the 5-min real-time price for the specified node, measured in $/MWh.',
            },
        ],
    },
    {
        name: 'ERCOT',
        mapLayerTitle: 'ERCOT',
        studies: [
            {
                name: 'Standardized Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'StandardizedCP_2020' },
                    { year: 2019, fieldName: 'StandardizedCP_2019' },
                    { year: 2018, fieldName: 'StandardizedCP_2018' },
                    { year: 2017, fieldName: 'StandardizedCP_2017' },
                    { year: 2016, fieldName: 'StandardizedCP_2016' },
                    { year: 'Overall', fieldName: 'StandardizedCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The standardized CP is the absolute CP divided by $50,000/MW.',
            },
            {
                name: 'Relative Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'RelativeCP_2020' },
                    { year: 2019, fieldName: 'RelativeCP_2019' },
                    { year: 2018, fieldName: 'RelativeCP_2018' },
                    { year: 2017, fieldName: 'RelativeCP_2017' },
                    { year: 2016, fieldName: 'RelativeCP_2016' },
                    { year: 'Overall', fieldName: 'RelativeCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The relative CP is the absolute CP divided by the median absolute CP for the specified year/ISO. The median CPs for each year are as follows, in $/MW.2016: $22955, 2017: $30306, 2018: $44162, 2019: $60000, 2020: $22781.',
            },
            {
                name: 'DA Basis',
                years: [
                    { year: 2020, fieldName: 'DABasis_2020' },
                    { year: 2019, fieldName: 'DABasis_2019' },
                    { year: 2018, fieldName: 'DABasis_2018' },
                    { year: 2017, fieldName: 'DABasis_2017' },
                    { year: 2016, fieldName: 'DABasis_2016' },
                    { year: 'Overall', fieldName: 'DABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub. The basis for a node in ERCOT is defined relative to HB_WEST, HB_HOUSTON, HB_SOUTH, or HB_NORTH, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'DART Spread',
                years: [
                    { year: 2020, fieldName: 'DARTSpread_2020' },
                    { year: 2019, fieldName: 'DARTSpread_2019' },
                    { year: 2018, fieldName: 'DARTSpread_2018' },
                    { year: 2017, fieldName: 'DARTSpread_2017' },
                    { year: 2016, fieldName: 'DARTSpread_2016' },
                    { year: 'Overall', fieldName: 'DARTSpread_Overall' },
                ],
                description:
                    'The DART spread is the arithmetic mean of the difference between day-ahead and real-time prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean DA Price',
                years: [
                    { year: 2020, fieldName: 'MeanDAPrice_2020' },
                    { year: 2019, fieldName: 'MeanDAPrice_2019' },
                    { year: 2018, fieldName: 'MeanDAPrice_2018' },
                    { year: 2017, fieldName: 'MeanDAPrice_2017' },
                    { year: 2016, fieldName: 'MeanDAPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanDAPrice_2020' },
                ],
                description:
                    'The mean DA price is the arithmetic mean of all day-ahead prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean Peak Price',
                years: [
                    { year: 2020, fieldName: 'MeanPeakPrice_2020' },
                    { year: 2019, fieldName: 'MeanPeakPrice_2019' },
                    { year: 2018, fieldName: 'MeanPeakPrice_2018' },
                    { year: 2017, fieldName: 'MeanPeakPrice_2017' },
                    { year: 2016, fieldName: 'MeanPeakPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanPeakPrice_Overall' },
                ],
                description:
                    'The mean peak price is the arithmetic mean of all real-time prices for the specified node during summer evening hours, measured in $/MWh.',
            },
            {
                name: 'Mean RT Price',
                years: [
                    { year: 2020, fieldName: 'MeanRTPrice_2020' },
                    { year: 2019, fieldName: 'MeanRTPrice_2019' },
                    { year: 2018, fieldName: 'MeanRTPrice_2018' },
                    { year: 2017, fieldName: 'MeanRTPrice_2017' },
                    { year: 2016, fieldName: 'MeanRTPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanRTPrice_Overall' },
                ],
            },
            {
                name: 'RT Basis',
                years: [
                    { year: 2020, fieldName: 'RTBasis_2020' },
                    { year: 2019, fieldName: 'RTBasis_2019' },
                    { year: 2018, fieldName: 'RTBasis_2018' },
                    { year: 2017, fieldName: 'RTBasis_2017' },
                    { year: 2016, fieldName: 'RTBasis_2016' },
                    { year: 'Overall', fieldName: 'RTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub. The basis for a node in ERCOT is defined relative to HB_WEST, HB_HOUSTON, HB_SOUTH, or HB_NORTH, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted Avg Price',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedAveragePrice_2020' },
                    { year: 2019, fieldName: 'Solar_weightedAveragePrice_2019' },
                    { year: 2018, fieldName: 'Solar_weightedAveragePrice_2018' },
                    { year: 2017, fieldName: 'Solar_weightedAveragePrice_2017' },
                    { year: 2016, fieldName: 'Solar_weightedAveragePrice_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedAveragePrice_Over' },
                ],
                description:
                    'The solar-weighted average price is the arithmetic mean of all real-time prices for the specified node, weighted by solar production at its location. The metric is measured in $/MWh. It can be interpreted as the average price that each MWh of solar energy can be expected to sell for.',
            },
            {
                name: 'Solar-weighted DA Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedDABasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedDABasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedDABasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedDABasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedDABasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedDABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub, weighted by solar-energy production. The basis for a node in ERCOT is defined relative to HB_WEST, HB_HOUSTON, HB_SOUTH, or HB_NORTH, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted RT Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedRTBasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedRTBasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedRTBasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedRTBasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedRTBasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedRTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub, weighted by solar-energy production. The basis for a node in ERCOT is defined relative to HB_WEST, HB_HOUSTON, HB_SOUTH, or HB_NORTH, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Volatility',
                years: [
                    { year: 2020, fieldName: 'Volatility_2020' },
                    { year: 2019, fieldName: 'Volatility_2019' },
                    { year: 2018, fieldName: 'Volatility_2018' },
                    { year: 2017, fieldName: 'Volatility_2017' },
                    { year: 2016, fieldName: 'Volatility_2016' },
                    { year: 'Overall', fieldName: 'Volatility_Overall' },
                ],
                description:
                    'Volatility is the standard deviation of the 5-min real-time price for the specified node, measured in $/MWh.',
            },
        ],
    },
    {
        name: 'ISO-NE',
        mapLayerTitle: 'ISO-NE',
        studies: [
            {
                name: 'Standardized Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'StandardizedCP_2020' },
                    { year: 2019, fieldName: 'StandardizedCP_2019' },
                    { year: 2018, fieldName: 'StandardizedCP_2018' },
                    { year: 2017, fieldName: 'StandardizedCP_2017' },
                    { year: 2016, fieldName: 'StandardizedCP_2016' },
                    { year: 'Overall', fieldName: 'StandardizedCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The standardized CP is the absolute CP divided by $50,000/MW.',
            },
            {
                name: 'Relative Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'RelativeCP_2020' },
                    { year: 2019, fieldName: 'RelativeCP_2019' },
                    { year: 2018, fieldName: 'RelativeCP_2018' },
                    { year: 2017, fieldName: 'RelativeCP_2017' },
                    { year: 2016, fieldName: 'RelativeCP_2016' },
                    { year: 'Overall', fieldName: 'RelativeCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The relative CP is the absolute CP divided by the median absolute CP for the specified year/ISO. The median CPs for each year are as follows, in $/MW.2016: $32410, 2017: $52183, 2018: $95688, 2019: $21538, 2020: $8277.',
            },
            {
                name: 'DA Basis',
                years: [
                    { year: 2020, fieldName: 'DABasis_2020' },
                    { year: 2019, fieldName: 'DABasis_2019' },
                    { year: 2018, fieldName: 'DABasis_2018' },
                    { year: 2017, fieldName: 'DABasis_2017' },
                    { year: 2016, fieldName: 'DABasis_2016' },
                    { year: 'Overall', fieldName: 'DABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub. The basis for a node in ISONE is defined relative to .Z.MAINE, .Z.SEMASS, .Z.WCMASS, .Z.RHODEISLAND, .Z.NEMASSBOST, .Z.CONNECTICUT, .Z.NEWHAMPSHIRE, or .Z.VERMONT, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'DART Spread',
                years: [
                    { year: 2020, fieldName: 'DARTSpread_2020' },
                    { year: 2019, fieldName: 'DARTSpread_2019' },
                    { year: 2018, fieldName: 'DARTSpread_2018' },
                    { year: 2017, fieldName: 'DARTSpread_2017' },
                    { year: 2016, fieldName: 'DARTSpread_2016' },
                    { year: 'Overall', fieldName: 'DARTSpread_Overall' },
                ],
                description:
                    'The DART spread is the arithmetic mean of the difference between day-ahead and real-time prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean DA Price',
                years: [
                    { year: 2020, fieldName: 'MeanDAPrice_2020' },
                    { year: 2019, fieldName: 'MeanDAPrice_2019' },
                    { year: 2018, fieldName: 'MeanDAPrice_2018' },
                    { year: 2017, fieldName: 'MeanDAPrice_2017' },
                    { year: 2016, fieldName: 'MeanDAPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanDAPrice_2020' },
                ],
                description:
                    'The mean DA price is the arithmetic mean of all day-ahead prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean Peak Price',
                years: [
                    { year: 2020, fieldName: 'MeanPeakPrice_2020' },
                    { year: 2019, fieldName: 'MeanPeakPrice_2019' },
                    { year: 2018, fieldName: 'MeanPeakPrice_2018' },
                    { year: 2017, fieldName: 'MeanPeakPrice_2017' },
                    { year: 2016, fieldName: 'MeanPeakPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanPeakPrice_Overall' },
                ],
                description:
                    'The mean peak price is the arithmetic mean of all real-time prices for the specified node during summer evening hours, measured in $/MWh.',
            },
            {
                name: 'Mean RT Price',
                years: [
                    { year: 2020, fieldName: 'MeanRTPrice_2020' },
                    { year: 2019, fieldName: 'MeanRTPrice_2019' },
                    { year: 2018, fieldName: 'MeanRTPrice_2018' },
                    { year: 2017, fieldName: 'MeanRTPrice_2017' },
                    { year: 2016, fieldName: 'MeanRTPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanRTPrice_Overall' },
                ],
            },
            {
                name: 'RT Basis',
                years: [
                    { year: 2020, fieldName: 'RTBasis_2020' },
                    { year: 2019, fieldName: 'RTBasis_2019' },
                    { year: 2018, fieldName: 'RTBasis_2018' },
                    { year: 2017, fieldName: 'RTBasis_2017' },
                    { year: 2016, fieldName: 'RTBasis_2016' },
                    { year: 'Overall', fieldName: 'RTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub. The basis for a node in ISONE is defined relative to .Z.MAINE, .Z.SEMASS, .Z.WCMASS, .Z.RHODEISLAND, .Z.NEMASSBOST, .Z.CONNECTICUT, .Z.NEWHAMPSHIRE, or .Z.VERMONT, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted Avg Price',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedAveragePrice_2020' },
                    { year: 2019, fieldName: 'Solar_weightedAveragePrice_2019' },
                    { year: 2018, fieldName: 'Solar_weightedAveragePrice_2018' },
                    { year: 2017, fieldName: 'Solar_weightedAveragePrice_2017' },
                    { year: 2016, fieldName: 'Solar_weightedAveragePrice_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedAveragePrice_Over' },
                ],
                description:
                    'The solar-weighted average price is the arithmetic mean of all real-time prices for the specified node, weighted by solar production at its location. The metric is measured in $/MWh. It can be interpreted as the average price that each MWh of solar energy can be expected to sell for.',
            },
            {
                name: 'Solar-weighted DA Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedDABasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedDABasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedDABasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedDABasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedDABasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedDABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub, weighted by solar-energy production. The basis for a node in ISONE is defined relative to .Z.MAINE, .Z.SEMASS, .Z.WCMASS, .Z.RHODEISLAND, .Z.NEMASSBOST, .Z.CONNECTICUT, .Z.NEWHAMPSHIRE, or .Z.VERMONT, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted RT Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedRTBasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedRTBasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedRTBasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedRTBasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedRTBasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedRTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub, weighted by solar-energy production. The basis for a node in ISONE is defined relative to .Z.MAINE, .Z.SEMASS, .Z.WCMASS, .Z.RHODEISLAND, .Z.NEMASSBOST, .Z.CONNECTICUT, .Z.NEWHAMPSHIRE, or .Z.VERMONT, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Volatility',
                years: [
                    { year: 2020, fieldName: 'Volatility_2020' },
                    { year: 2019, fieldName: 'Volatility_2019' },
                    { year: 2018, fieldName: 'Volatility_2018' },
                    { year: 2017, fieldName: 'Volatility_2017' },
                    { year: 2016, fieldName: 'Volatility_2016' },
                    { year: 'Overall', fieldName: 'Volatility_Overall' },
                ],
                description:
                    'Volatility is the standard deviation of the 5-min real-time price for the specified node, measured in $/MWh.',
            },
        ],
    },
    {
        name: 'MISO',
        mapLayerTitle: 'MISO',
        studies: [
            {
                name: 'Standardized Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'StandardizedCP_2020' },
                    { year: 2019, fieldName: 'StandardizedCP_2019' },
                    { year: 2018, fieldName: 'StandardizedCP_2018' },
                    { year: 2017, fieldName: 'StandardizedCP_2017' },
                    { year: 2016, fieldName: 'StandardizedCP_2016' },
                    { year: 'Overall', fieldName: 'StandardizedCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The standardized CP is the absolute CP divided by $50,000/MW.',
            },
            {
                name: 'Relative Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'RelativeCP_2020' },
                    { year: 2019, fieldName: 'RelativeCP_2019' },
                    { year: 2018, fieldName: 'RelativeCP_2018' },
                    { year: 2017, fieldName: 'RelativeCP_2017' },
                    { year: 2016, fieldName: 'RelativeCP_2016' },
                    { year: 'Overall', fieldName: 'RelativeCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The relative CP is the absolute CP divided by the median absolute CP for the specified year/ISO. The median CPs for each year are as follows, in $/MW.2016: $14893, 2017: $16544, 2018: $19457, 2019: $13578, 2020: $12802.',
            },
            {
                name: 'DA Basis',
                years: [
                    { year: 2020, fieldName: 'DABasis_2020' },
                    { year: 2019, fieldName: 'DABasis_2019' },
                    { year: 2018, fieldName: 'DABasis_2018' },
                    { year: 2017, fieldName: 'DABasis_2017' },
                    { year: 2016, fieldName: 'DABasis_2016' },
                    { year: 'Overall', fieldName: 'DABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub. The basis for a node in MISO is defined relative to ILLINOIS.HUB, INDIANA.HUB, MICHIGAN.HUB, MINN.HUB, LOUISIANA.HUB, TEXAS.HUB, ARKANSAS.HUB, or MS.HUB, depending on location. Node-to-hub mappings are determined by grouping nodes by local balancing authority and reserve zone.',
            },
            {
                name: 'DART Spread',
                years: [
                    { year: 2020, fieldName: 'DARTSpread_2020' },
                    { year: 2019, fieldName: 'DARTSpread_2019' },
                    { year: 2018, fieldName: 'DARTSpread_2018' },
                    { year: 2017, fieldName: 'DARTSpread_2017' },
                    { year: 2016, fieldName: 'DARTSpread_2016' },
                    { year: 'Overall', fieldName: 'DARTSpread_Overall' },
                ],
                description:
                    'The DART spread is the arithmetic mean of the difference between day-ahead and real-time prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean DA Price',
                years: [
                    { year: 2020, fieldName: 'MeanDAPrice_2020' },
                    { year: 2019, fieldName: 'MeanDAPrice_2019' },
                    { year: 2018, fieldName: 'MeanDAPrice_2018' },
                    { year: 2017, fieldName: 'MeanDAPrice_2017' },
                    { year: 2016, fieldName: 'MeanDAPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanDAPrice_2020' },
                ],
                description:
                    'The mean DA price is the arithmetic mean of all day-ahead prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean Peak Price',
                years: [
                    { year: 2020, fieldName: 'MeanPeakPrice_2020' },
                    { year: 2019, fieldName: 'MeanPeakPrice_2019' },
                    { year: 2018, fieldName: 'MeanPeakPrice_2018' },
                    { year: 2017, fieldName: 'MeanPeakPrice_2017' },
                    { year: 2016, fieldName: 'MeanPeakPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanPeakPrice_Overall' },
                ],
                description:
                    'The mean peak price is the arithmetic mean of all real-time prices for the specified node during summer evening hours, measured in $/MWh.',
            },
            {
                name: 'Mean RT Price',
                years: [
                    { year: 2020, fieldName: 'MeanRTPrice_2020' },
                    { year: 2019, fieldName: 'MeanRTPrice_2019' },
                    { year: 2018, fieldName: 'MeanRTPrice_2018' },
                    { year: 2017, fieldName: 'MeanRTPrice_2017' },
                    { year: 2016, fieldName: 'MeanRTPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanRTPrice_Overall' },
                ],
            },
            {
                name: 'RT Basis',
                years: [
                    { year: 2020, fieldName: 'RTBasis_2020' },
                    { year: 2019, fieldName: 'RTBasis_2019' },
                    { year: 2018, fieldName: 'RTBasis_2018' },
                    { year: 2017, fieldName: 'RTBasis_2017' },
                    { year: 2016, fieldName: 'RTBasis_2016' },
                    { year: 'Overall', fieldName: 'RTBasis_Overall' },
                ],
                description:
                    'he RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub. The basis for a node in MISO is defined relative to ILLINOIS.HUB, INDIANA.HUB, MICHIGAN.HUB, MINN.HUB, LOUISIANA.HUB, TEXAS.HUB, ARKANSAS.HUB, or MS.HUB, depending on location. Node-to-hub mappings are determined by grouping nodes by local balancing authority and reserve zone.',
            },
            {
                name: 'Solar-weighted Avg Price',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedAveragePrice_2020' },
                    { year: 2019, fieldName: 'Solar_weightedAveragePrice_2019' },
                    { year: 2018, fieldName: 'Solar_weightedAveragePrice_2018' },
                    { year: 2017, fieldName: 'Solar_weightedAveragePrice_2017' },
                    { year: 2016, fieldName: 'Solar_weightedAveragePrice_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedAveragePrice_Over' },
                ],
                description:
                    'The solar-weighted average price is the arithmetic mean of all real-time prices for the specified node, weighted by solar production at its location. The metric is measured in $/MWh. It can be interpreted as the average price that each MWh of solar energy can be expected to sell for.',
            },
            {
                name: 'Solar-weighted DA Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedDABasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedDABasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedDABasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedDABasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedDABasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedDABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub, weighted by solar-energy production. The basis for a node in MISO is defined relative to ILLINOIS.HUB, INDIANA.HUB, MICHIGAN.HUB, MINN.HUB, LOUISIANA.HUB, TEXAS.HUB, ARKANSAS.HUB, or MS.HUB, depending on location. Node-to-hub mappings are determined by grouping nodes by local balancing authority and reserve zone.',
            },
            {
                name: 'Solar-weighted RT Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedRTBasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedRTBasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedRTBasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedRTBasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedRTBasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedRTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub, weighted by solar-energy production. The basis for a node in MISO is defined relative to ILLINOIS.HUB, INDIANA.HUB, MICHIGAN.HUB, MINN.HUB, LOUISIANA.HUB, TEXAS.HUB, ARKANSAS.HUB, or MS.HUB, depending on location. Node-to-hub mappings are determined by grouping nodes by local balancing authority and reserve zone.',
            },
            {
                name: 'Volatility',
                years: [
                    { year: 2020, fieldName: 'Volatility_2020' },
                    { year: 2019, fieldName: 'Volatility_2019' },
                    { year: 2018, fieldName: 'Volatility_2018' },
                    { year: 2017, fieldName: 'Volatility_2017' },
                    { year: 2016, fieldName: 'Volatility_2016' },
                    { year: 'Overall', fieldName: 'Volatility_Overall' },
                ],
                description:
                    'Volatility is the standard deviation of the 5-min real-time price for the specified node, measured in $/MWh.',
            },
        ],
    },
    {
        name: 'NYISO',
        mapLayerTitle: 'NYISO',
        studies: [
            {
                name: 'Standardized Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'StandardizedCP_2020' },
                    { year: 2019, fieldName: 'StandardizedCP_2019' },
                    { year: 2018, fieldName: 'StandardizedCP_2018' },
                    { year: 2017, fieldName: 'StandardizedCP_2017' },
                    { year: 2016, fieldName: 'StandardizedCP_2016' },
                    { year: 'Overall', fieldName: 'StandardizedCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The standardized CP is the absolute CP divided by $50,000/MW.',
            },
            {
                name: 'Relative Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'RelativeCP_2020' },
                    { year: 2019, fieldName: 'RelativeCP_2019' },
                    { year: 2018, fieldName: 'RelativeCP_2018' },
                    { year: 2017, fieldName: 'RelativeCP_2017' },
                    { year: 2016, fieldName: 'RelativeCP_2016' },
                    { year: 'Overall', fieldName: 'RelativeCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The relative CP is the absolute CP divided by the median absolute CP for the specified year/ISO. The median CPs for each year are as follows, in $/MW.2016: $34372, 2017: $46847, 2018: $88476, 2019: $21154, 2020: $12074.',
            },
            {
                name: 'DA Basis',
                years: [
                    { year: 2020, fieldName: 'DABasis_2020' },
                    { year: 2019, fieldName: 'DABasis_2019' },
                    { year: 2018, fieldName: 'DABasis_2018' },
                    { year: 2017, fieldName: 'DABasis_2017' },
                    { year: 2016, fieldName: 'DABasis_2016' },
                    { year: 'Overall', fieldName: 'DABasis_Overall' },
                ],
                description:
                    'he DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub. The basis for a node in NYISO is defined relative to WEST, GENESE, CENTRL, NORTH, MHK VL, CAPITL, HUD VL, MILLWD, DUNWOD, N.Y.C., or LONGIL, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'DART Spread',
                years: [
                    { year: 2020, fieldName: 'DARTSpread_2020' },
                    { year: 2019, fieldName: 'DARTSpread_2019' },
                    { year: 2018, fieldName: 'DARTSpread_2018' },
                    { year: 2017, fieldName: 'DARTSpread_2017' },
                    { year: 2016, fieldName: 'DARTSpread_2016' },
                    { year: 'Overall', fieldName: 'DARTSpread_Overall' },
                ],
                description:
                    'The DART spread is the arithmetic mean of the difference between day-ahead and real-time prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean DA Price',
                years: [
                    { year: 2020, fieldName: 'MeanDAPrice_2020' },
                    { year: 2019, fieldName: 'MeanDAPrice_2019' },
                    { year: 2018, fieldName: 'MeanDAPrice_2018' },
                    { year: 2017, fieldName: 'MeanDAPrice_2017' },
                    { year: 2016, fieldName: 'MeanDAPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanDAPrice_2020' },
                ],
                description:
                    'The mean DA price is the arithmetic mean of all day-ahead prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean Peak Price',
                years: [
                    { year: 2020, fieldName: 'MeanPeakPrice_2020' },
                    { year: 2019, fieldName: 'MeanPeakPrice_2019' },
                    { year: 2018, fieldName: 'MeanPeakPrice_2018' },
                    { year: 2017, fieldName: 'MeanPeakPrice_2017' },
                    { year: 2016, fieldName: 'MeanPeakPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanPeakPrice_Overall' },
                ],
                description:
                    'The mean peak price is the arithmetic mean of all real-time prices for the specified node during summer evening hours, measured in $/MWh.',
            },
            {
                name: 'Mean RT Price',
                years: [
                    { year: 2020, fieldName: 'MeanRTPrice_2020' },
                    { year: 2019, fieldName: 'MeanRTPrice_2019' },
                    { year: 2018, fieldName: 'MeanRTPrice_2018' },
                    { year: 2017, fieldName: 'MeanRTPrice_2017' },
                    { year: 2016, fieldName: 'MeanRTPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanRTPrice_Overall' },
                ],
            },
            {
                name: 'RT Basis',
                years: [
                    { year: 2020, fieldName: 'RTBasis_2020' },
                    { year: 2019, fieldName: 'RTBasis_2019' },
                    { year: 2018, fieldName: 'RTBasis_2018' },
                    { year: 2017, fieldName: 'RTBasis_2017' },
                    { year: 2016, fieldName: 'RTBasis_2016' },
                    { year: 'Overall', fieldName: 'RTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub. The basis for a node in NYISO is defined relative to WEST, GENESE, CENTRL, NORTH, MHK VL, CAPITL, HUD VL, MILLWD, DUNWOD, N.Y.C., or LONGIL, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted Avg Price',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedAveragePrice_2020' },
                    { year: 2019, fieldName: 'Solar_weightedAveragePrice_2019' },
                    { year: 2018, fieldName: 'Solar_weightedAveragePrice_2018' },
                    { year: 2017, fieldName: 'Solar_weightedAveragePrice_2017' },
                    { year: 2016, fieldName: 'Solar_weightedAveragePrice_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedAveragePrice_Over' },
                ],
                description:
                    'The solar-weighted average price is the arithmetic mean of all real-time prices for the specified node, weighted by solar production at its location. The metric is measured in $/MWh. It can be interpreted as the average price that each MWh of solar energy can be expected to sell for.',
            },
            {
                name: 'Solar-weighted DA Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedDABasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedDABasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedDABasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedDABasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedDABasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedDABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub, weighted by solar-energy production. The basis for a node in NYISO is defined relative to WEST, GENESE, CENTRL, NORTH, MHK VL, CAPITL, HUD VL, MILLWD, DUNWOD, N.Y.C., or LONGIL, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Solar-weighted RT Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedRTBasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedRTBasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedRTBasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedRTBasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedRTBasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedRTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub, weighted by solar-energy production. The basis for a node in NYISO is defined relative to WEST, GENESE, CENTRL, NORTH, MHK VL, CAPITL, HUD VL, MILLWD, DUNWOD, N.Y.C., or LONGIL, depending on location. Node-to-hub mappings are available from the ISO.',
            },
            {
                name: 'Volatility',
                years: [
                    { year: 2020, fieldName: 'Volatility_2020' },
                    { year: 2019, fieldName: 'Volatility_2019' },
                    { year: 2018, fieldName: 'Volatility_2018' },
                    { year: 2017, fieldName: 'Volatility_2017' },
                    { year: 2016, fieldName: 'Volatility_2016' },
                    { year: 'Overall', fieldName: 'Volatility_Overall' },
                ],
                description:
                    'Volatility is the standard deviation of the 5-min real-time price for the specified node, measured in $/MWh.',
            },
        ],
    },
    {
        name: 'PJM',
        mapLayerTitle: 'PJM',
        studies: [
            {
                name: 'Standardized Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'StandardizedCP_2020' },
                    { year: 2019, fieldName: 'StandardizedCP_2019' },
                    { year: 'Overall', fieldName: 'StandardizedCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The standardized CP is the absolute CP divided by $50,000/MW.',
            },
            {
                name: 'Relative Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'RelativeCP_2020' },
                    { year: 2019, fieldName: 'RelativeCP_2019' },
                    { year: 'Overall', fieldName: 'RelativeCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The relative CP is the absolute CP divided by the median absolute CP for the specified year/ISO. The median CPs for each year are as follows, in $/MW.2019: $19468, 2020: $12969.',
            },
            {
                name: 'DA Basis',
                years: [
                    { year: 2020, fieldName: 'DABasis_2020' },
                    { year: 2019, fieldName: 'DABasis_2019' },
                    { year: 'Overall', fieldName: 'DABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub. The basis for a node in PJM is defined relative to AEP-DAYTON HUB, ATSI GEN HUB, CHICAGO GEN HUB, CHICAGO HUB, DOMINION HUB, EASTERN HUB, N ILLINOIS HUB, NEW JERSEY HUB, OHIO HUB, WEST INT HUB, WESTERN HUB, or AEP GEN HUB, depending on location. The node to hub mapping is determined from the hub definitions, as available from the ISO.',
            },
            {
                name: 'DART Spread',
                years: [
                    { year: 2020, fieldName: 'DARTSpread_2020' },
                    { year: 2019, fieldName: 'DARTSpread_2019' },
                    { year: 'Overall', fieldName: 'DARTSpread_Overall' },
                ],
                description:
                    'The DART spread is the arithmetic mean of the difference between day-ahead and real-time prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean DA Price',
                years: [
                    { year: 2020, fieldName: 'MeanDAPrice_2020' },
                    { year: 2019, fieldName: 'MeanDAPrice_2019' },
                    { year: 'Overall', fieldName: 'MeanDAPrice_2020' },
                ],
                description:
                    'The mean DA price is the arithmetic mean of all day-ahead prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean Peak Price',
                years: [
                    { year: 2020, fieldName: 'MeanPeakPrice_2020' },
                    { year: 2019, fieldName: 'MeanPeakPrice_2019' },
                    { year: 'Overall', fieldName: 'MeanPeakPrice_Overall' },
                ],
                description:
                    'The mean peak price is the arithmetic mean of all real-time prices for the specified node during summer evening hours, measured in $/MWh.',
            },
            {
                name: 'Mean RT Price',
                years: [
                    { year: 2020, fieldName: 'MeanRTPrice_2020' },
                    { year: 2019, fieldName: 'MeanRTPrice_2019' },
                    { year: 'Overall', fieldName: 'MeanRTPrice_Overall' },
                ],
            },
            {
                name: 'RT Basis',
                years: [
                    { year: 2020, fieldName: 'RTBasis_2020' },
                    { year: 2019, fieldName: 'RTBasis_2019' },
                    { year: 'Overall', fieldName: 'RTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub. The basis for a node in PJM is defined relative to AEP-DAYTON HUB, ATSI GEN HUB, CHICAGO GEN HUB, CHICAGO HUB, DOMINION HUB, EASTERN HUB, N ILLINOIS HUB, NEW JERSEY HUB, OHIO HUB, WEST INT HUB, WESTERN HUB, or AEP GEN HUB, depending on location. The node to hub mapping is determined from the hub definitions, as available from the ISO.',
            },
            {
                name: 'Solar-weighted Avg Price',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedAveragePrice_2020' },
                    { year: 2019, fieldName: 'Solar_weightedAveragePrice_2019' },
                    { year: 'Overall', fieldName: 'Solar_weightedAveragePrice_Over' },
                ],
                description:
                    'The solar-weighted average price is the arithmetic mean of all real-time prices for the specified node, weighted by solar production at its location. The metric is measured in $/MWh. It can be interpreted as the average price that each MWh of solar energy can be expected to sell for.',
            },
            {
                name: 'Solar-weighted DA Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedDABasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedDABasis_2019' },
                    { year: 'Overall', fieldName: 'Solar_weightedDABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub, weighted by solar-energy production. The basis for a node in PJM is defined relative to AEP-DAYTON HUB, ATSI GEN HUB, CHICAGO GEN HUB, CHICAGO HUB, DOMINION HUB, EASTERN HUB, N ILLINOIS HUB, NEW JERSEY HUB, OHIO HUB, WEST INT HUB, WESTERN HUB, or AEP GEN HUB, depending on location. The node to hub mapping is determined from the hub definitions, as available from the ISO.',
            },
            {
                name: 'Solar-weighted RT Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedRTBasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedRTBasis_2019' },
                    { year: 'Overall', fieldName: 'Solar_weightedRTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub, weighted by solar-energy production. The basis for a node in PJM is defined relative to AEP-DAYTON HUB, ATSI GEN HUB, CHICAGO GEN HUB, CHICAGO HUB, DOMINION HUB, EASTERN HUB, N ILLINOIS HUB, NEW JERSEY HUB, OHIO HUB, WEST INT HUB, WESTERN HUB, or AEP GEN HUB, depending on location. The node to hub mapping is determined from the hub definitions, as available from the ISO.',
            },
            {
                name: 'Volatility',
                years: [
                    { year: 2020, fieldName: 'Volatility_2020' },
                    { year: 2019, fieldName: 'Volatility_2019' },
                    { year: 'Overall', fieldName: 'Volatility_Overall' },
                ],
                description:
                    'Volatility is the standard deviation of the 5-min real-time price for the specified node, measured in $/MWh.',
            },
        ],
    },
    {
        name: 'SPP',
        mapLayerTitle: 'SPP',
        studies: [
            {
                name: 'Standardized Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'StandardizedCP_2020' },
                    { year: 2019, fieldName: 'StandardizedCP_2019' },
                    { year: 2018, fieldName: 'StandardizedCP_2018' },
                    { year: 2017, fieldName: 'StandardizedCP_2017' },
                    { year: 2016, fieldName: 'StandardizedCP_2016' },
                    { year: 'Overall', fieldName: 'StandardizedCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The standardized CP is the absolute CP divided by $50,000/MW.',
            },
            {
                name: 'Relative Congestion Persistence',
                years: [
                    { year: 2020, fieldName: 'RelativeCP_2020' },
                    { year: 2019, fieldName: 'RelativeCP_2019' },
                    { year: 2018, fieldName: 'RelativeCP_2018' },
                    { year: 2017, fieldName: 'RelativeCP_2017' },
                    { year: 2016, fieldName: 'RelativeCP_2016' },
                    { year: 'Overall', fieldName: 'RelativeCP_Overall' },
                ],
                description:
                    'The absolute congestion persistence (CP) is the sum of all price spikes above $100 and below $0, providing an approximation of battery arbitrage revenue. The relative CP is the absolute CP divided by the median absolute CP for the specified year/ISO. The median CPs for each year are as follows, in $/MW.2016: $21634, 2017: $41985, 2018: $46504, 2019: $54804, 2020: $48358.',
            },
            {
                name: 'DA Basis',
                years: [
                    { year: 2020, fieldName: 'DABasis_2020' },
                    { year: 2019, fieldName: 'DABasis_2019' },
                    { year: 2018, fieldName: 'DABasis_2018' },
                    { year: 2017, fieldName: 'DABasis_2017' },
                    { year: 2016, fieldName: 'DABasis_2016' },
                    { year: 'Overall', fieldName: 'DABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub. The basis for a node in SPP is defined relative to SPPNORTH_HUB for all nodes, regardless of location.',
            },
            {
                name: 'DART Spread',
                years: [
                    { year: 2020, fieldName: 'DARTSpread_2020' },
                    { year: 2019, fieldName: 'DARTSpread_2019' },
                    { year: 2018, fieldName: 'DARTSpread_2018' },
                    { year: 2017, fieldName: 'DARTSpread_2017' },
                    { year: 2016, fieldName: 'DARTSpread_2016' },
                    { year: 'Overall', fieldName: 'DARTSpread_Overall' },
                ],
                description:
                    'The DART spread is the arithmetic mean of the difference between day-ahead and real-time prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean DA Price',
                years: [
                    { year: 2020, fieldName: 'MeanDAPrice_2020' },
                    { year: 2019, fieldName: 'MeanDAPrice_2019' },
                    { year: 2018, fieldName: 'MeanDAPrice_2018' },
                    { year: 2017, fieldName: 'MeanDAPrice_2017' },
                    { year: 2016, fieldName: 'MeanDAPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanDAPrice_2020' },
                ],
                description:
                    'The mean DA price is the arithmetic mean of all day-ahead prices for the specified node, measured in $/MWh.',
            },
            {
                name: 'Mean Peak Price',
                years: [
                    { year: 2020, fieldName: 'MeanPeakPrice_2020' },
                    { year: 2019, fieldName: 'MeanPeakPrice_2019' },
                    { year: 2018, fieldName: 'MeanPeakPrice_2018' },
                    { year: 2017, fieldName: 'MeanPeakPrice_2017' },
                    { year: 2016, fieldName: 'MeanPeakPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanPeakPrice_Overall' },
                ],
                description:
                    'The mean peak price is the arithmetic mean of all real-time prices for the specified node during summer evening hours, measured in $/MWh.',
            },
            {
                name: 'Mean RT Price',
                years: [
                    { year: 2020, fieldName: 'MeanRTPrice_2020' },
                    { year: 2019, fieldName: 'MeanRTPrice_2019' },
                    { year: 2018, fieldName: 'MeanRTPrice_2018' },
                    { year: 2017, fieldName: 'MeanRTPrice_2017' },
                    { year: 2016, fieldName: 'MeanRTPrice_2016' },
                    { year: 'Overall', fieldName: 'MeanRTPrice_Overall' },
                ],
            },
            {
                name: 'RT Basis',
                years: [
                    { year: 2020, fieldName: 'RTBasis_2020' },
                    { year: 2019, fieldName: 'RTBasis_2019' },
                    { year: 2018, fieldName: 'RTBasis_2018' },
                    { year: 2017, fieldName: 'RTBasis_2017' },
                    { year: 2016, fieldName: 'RTBasis_2016' },
                    { year: 'Overall', fieldName: 'RTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub. The basis for a node in SPP is defined relative to SPPNORTH_HUB for all nodes, regardless of location.',
            },
            {
                name: 'Solar-weighted Avg Price',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedAveragePrice_2020' },
                    { year: 2019, fieldName: 'Solar_weightedAveragePrice_2019' },
                    { year: 2018, fieldName: 'Solar_weightedAveragePrice_2018' },
                    { year: 2017, fieldName: 'Solar_weightedAveragePrice_2017' },
                    { year: 2016, fieldName: 'Solar_weightedAveragePrice_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedAveragePrice_Over' },
                ],
                description:
                    'The solar-weighted average price is the arithmetic mean of all real-time prices for the specified node, weighted by solar production at its location. The metric is measured in $/MWh. It can be interpreted as the average price that each MWh of solar energy can be expected to sell for.',
            },
            {
                name: 'Solar-weighted DA Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedDABasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedDABasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedDABasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedDABasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedDABasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedDABasis_Overall' },
                ],
                description:
                    'The DA basis is the average difference between the day-ahead prices at a node and the day-ahead prices at the corresponding hub, weighted by solar-energy production. The basis for a node in SPP is defined relative to SPPNORTH_HUB for all nodes, regardless of location.',
            },
            {
                name: 'Solar-weighted RT Basis',
                years: [
                    { year: 2020, fieldName: 'Solar_weightedRTBasis_2020' },
                    { year: 2019, fieldName: 'Solar_weightedRTBasis_2019' },
                    { year: 2018, fieldName: 'Solar_weightedRTBasis_2018' },
                    { year: 2017, fieldName: 'Solar_weightedRTBasis_2017' },
                    { year: 2016, fieldName: 'Solar_weightedRTBasis_2016' },
                    { year: 'Overall', fieldName: 'Solar_weightedRTBasis_Overall' },
                ],
                description:
                    'The RT basis is the average difference between the real-time prices at a node and the real-time prices at the corresponding hub, weighted by solar-energy production. The basis for a node in SPP is defined relative to SPPNORTH_HUB for all nodes, regardless of location.',
            },
            {
                name: 'Volatility',
                years: [
                    { year: 2020, fieldName: 'Volatility_2020' },
                    { year: 2019, fieldName: 'Volatility_2019' },
                    { year: 2018, fieldName: 'Volatility_2018' },
                    { year: 2017, fieldName: 'Volatility_2017' },
                    { year: 2016, fieldName: 'Volatility_2016' },
                    { year: 'Overall', fieldName: 'Volatility_Overall' },
                ],
                description:
                    'Volatility is the standard deviation of the 5-min real-time price for the specified node, measured in $/MWh.',
            },
        ],
    },
];
